import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { media } from 'styles'
import { useSimpleGeo } from 'hooks'
import { onSubmit } from 'utils'
import { REGISTRIES } from 'common/constants'
import { fetchRegistry, fetchConfirmation, confirmRegistration, fetchMyProfile, fetchLabels } from 'store/actions'
import { T, Button, Input, Select, TextArea, SiteLogo, Redirect } from 'components'
import Stockings from 'assets/images/stockings.png'

const StyledRegistrationConfirmation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  & > * {
    max-width: 50rem;
  }
  form {
    margin-right: 15rem;
    padding: 2rem;
  }
  .errorMsg {
    margin-left: 0;
  }
  img {
    max-height: 90vh;
    align-self: flex-start;
  }
  h1 {
    font-size: 3rem;
  }
  label {
    display: block;
  }
  label > span {
    display: inline-block;
    margin: 1rem 0;
  }
  button {
    width: 100%;
    margin-top: 2rem;
  }
  ${media.mobile`
    form {
      margin: 0;
    }
    img {
      display: none;
    }
  `}
`

const RegistrationConfirmation = () => {
  const dispatch = useDispatch()
  const registration = useSelector(s => s.account.registration)
  const countries = useSelector(s => s.registry.countries)
  const guest = useSelector(s => !!s.myProfile.error)

  useEffect(() => {
    dispatch(fetchRegistry([REGISTRIES.COUNTRIES]))
    dispatch(fetchConfirmation())
  }, [])

  useEffect(() => {
    if (registration.complete) {
      dispatch(fetchMyProfile())
      dispatch(fetchLabels())
    }
  }, [registration.complete])

  if (registration.complete && (!guest || registration.location)) {
    return <Redirect to={registration.location || '/'} />
  }
  if (!countries.length || registration.notLoaded) {
    return null
  }
  return <RegistrationConfirmationPage registration={registration} dispatch={dispatch} />
}

const RegistrationConfirmationPage = ({ registration, dispatch }) => {
  const { country, region, city } = useSimpleGeo({ country: { id: registration.data.countryId } })

  const [fields, setFields] = useState({ newPassword: '' })

  const onChange = ({ target: { value, name } }) => setFields({ ...fields, [name]: value })
  const submit = onSubmit(data => dispatch(confirmRegistration(data)), registration.data)

  return (
    <>
      <header className="app-header">
        <SiteLogo external />
      </header>
      <StyledRegistrationConfirmation>
        <form onSubmit={submit} onChange={onChange}>
          <T as="h1" label="tellOthers" />
          <T as="p" label="warningMandatoryFields|basicHTML" />

          <label>
            *<T as="span" label="password" />
            <Input name="newPassword" type="password" maxLength="20" hasError />
          </label>

          <label>
            *<T as="span" label="country" />
            <Select name="countryId" {...country} filterable />
          </label>

          <label>
            *<T as="span" label="city" />
            <Select name="cityId" {...city} filterable disabled={false} />
            <Input {...region} name="regionId" type="hidden" />
          </label>

          <label>
            <T as="p" label="greatOpportunity" />
            <T as="span" label="aboutMe|noColon" />:
            <TextArea name="userDescription" rows="5" hasError />
          </label>

          <Button
            type="submit"
            disabled={fields.newPassword.length < 6 || !fields.cityId}
            color="cta"
            size="large"
            label="complete"
          />
        </form>
        <img src={Stockings} alt="long legged woman" />
      </StyledRegistrationConfirmation>
    </>
  )
}

export default RegistrationConfirmation
